import React, { useEffect, useState } from 'react';
import { Grid, Dialog, Typography } from '@mui/material';
import CollectionItem from './CollectionItem';






export default function CollectionDialog({ dialog, setDialog, addToCart, loading }) {
  const { step, code } = dialog;
  const [products, setProducts] = useState([]);


  useEffect(() => {
    if (step?.type === 'modal') {
      fetch(`/collections/${step.collection}/products.json?limit=50`)
        .then(r => r.json())
        .then(p => setProducts(p.products))
        .catch(console.error)
    }
  }, [step])




  return (
    <Dialog disablePortal open={step?.type === 'modal'} onClose={() => setDialog(false)} sx={{ height: '100%', bgcolor: 'grey' }} PaperProps={{ sx: { height: '100%', bgcolor: 'grey' } }}>
      <Grid container direction='column' sx={{ height: '100%' }} wrap='nowrap'>
        <Grid item sx={{ backgroundColor: "#2bbdff", p: 2, }}>
          <Typography color='white' textAlign='center'>
            Choose your free product now! We're so excited to have you in #ThePack!!
          </Typography>
        </Grid>
        <Grid container spacing={2} item sx={{ overflowY: 'auto', minHeight: '50%', maxWidth: '100%', mt: 0, mb: 2 }}>
          {products.map((product, key) => (
            <Grid item xs={12} md={6} disabled={loading} >
              <CollectionItem {...{ product, key, loading, addToCart: (v) => addToCart(v, code) }} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Dialog>
  )
}

